/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarousel_viewer = {
    readonly isRequestMoreImagesEnabled: boolean | null;
    readonly " $refType": "PdpRespHeroCarousel_viewer";
};
export type PdpRespHeroCarousel_viewer$data = PdpRespHeroCarousel_viewer;
export type PdpRespHeroCarousel_viewer$key = {
    readonly " $data"?: PdpRespHeroCarousel_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarousel_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespHeroCarousel_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isRequestMoreImagesEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "REQUEST_MORE_IMAGES"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"REQUEST_MORE_IMAGES\")"
    }
  ]
};
(node as any).hash = 'ab3cafa173d6bac3db4a623edec508eb';
export default node;
